import { isEmbedded } from '../lib/PageHelpers.js';
import React, { useContext } from 'react';
import { ThemeContext } from '../../lib/ThemeContext.js';
import PoweredBy from '~/public/components/PoweredBy';
import { FormPart, part } from '~/lib/FormCssApi';

// `form` is for pages outside FormContextProvider (e.g. the standalone
//  confirmation page), so PoweredBy can still tell a free business apart
const PageContainer = ({ children, styles, hidePoweredBy, form, classNameNoBackground = '', centered = true, fillScreen = true }) => {
    const centerClass = centered ? 'mx-auto' : '';

    const { styles: themeStyles } = useContext(ThemeContext);

    styles = styles || themeStyles;
    const hasFullBackground =
        !!styles?.fullPageImage &&
        (!!styles?.headerImage || !!styles?.headerColor);

    return (
        <div>
            {!hidePoweredBy && (
                <PoweredBy form={form} className="pt-4 mb-4" showOnlyFree={true} />
            )}

            <div
                className={
                    (hasFullBackground ? '!pt-0 sm:!pt-4 ' : '') +
                    (!isEmbedded()
                        ? `${fillScreen ? 'min-h-screen ' : ''}w-full pt-4 ${centerClass}`
                        : '')
                }
            >
                <div
                    {...part(FormPart.CONTAINER)}
                    className={
                        'rounded-xl ' +
                        (hasFullBackground ? `${!isEmbedded() ? '' : ''} relative mb-4 p-3 sm:p-6 has-full-background max-w-[1050px] ${centerClass} w-full md:w-auto isolate before:content-[''] before:absolute before:inset-0 before:bg-[#FFFFFFAA] before:backdrop-blur before:rounded-xl before:-z-10`: `no-full-background max-w-[1050px] ${centerClass} px-4 w-full ${classNameNoBackground}`)
                        }
                    >
                    {children}
                </div>
                {!hidePoweredBy && <PoweredBy form={form} variant="promo" className="mt-6 pb-4" />}
            </div>
        </div>
    );
};

export default PageContainer;
